/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {DelTerritoryVoModel} from './del-territory-vo.model';
import {DelCustomerVO} from "./del-customer-vo.model";

export class DelCustomerExtendedVO extends DelCustomerVO {

  territoryVo: DelTerritoryVoModel | undefined = undefined;
  globalAccCode: string | undefined = undefined;
  globalAccType: string | undefined = undefined;
  globalAccUuid: string | undefined = undefined;
  favourite: boolean | undefined = undefined;
  walletBalanceCurrencyCode: string | undefined = undefined;
  walletBalanceValue: number | undefined = undefined;

  fromJSON(json: any) {
    super.fromJSON?.(json);

    if (!this.territoryVo) {
      this.territoryVo = new DelTerritoryVoModel();
    }
  }
}
